import { useEffect, useState } from "react";

import Carousel from "react-simply-carousel";
import iconPrevious from "assets/img/iconPrevious.png";
import iconNext from "assets/img/iconNext.png";
import iconPreviousWhite from "assets/img/iconPrevious-white.png";
import iconNextWhite from "assets/img/iconNext-white.png";
import { CustomVideo } from "./customVideo";

export const CarruselVideos = ({ width, videos }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      setIsDarkMode(true);
    }
  }, []);

  return (
    <Carousel
      activeSlideIndex={activeSlide}
      onRequestChange={setActiveSlide}
      itemsToShow={1}
      containerProps={{
        style: {
          width: "100%",
          height: "100%",
          justifyContent: "center",
          position: "relative",
        },
      }}
      backwardBtnProps={{
        children: (
          <img
            src={isDarkMode ? iconPreviousWhite : iconPrevious}
            className="imgLeft"
            alt={"previous"}
          />
        ),
        style: {
          width: 60,
          height: 60,
          minWidth: 60,
          alignSelf: "center",
          position: "absolute",
          bottom: "-8em",
          marginRight: 60,
          backgroundColor: "transparent",
          border: 0,
          cursor: "pointer",
        },
      }}
      forwardBtnProps={{
        children: (
          <img
            src={isDarkMode ? iconNextWhite : iconNext}
            className="imgRight"
            alt={"next"}
          />
        ),
        style: {
          width: 60,
          height: 60,
          minWidth: 60,
          alignSelf: "center",
          position: "absolute",
          bottom: "-8em",
          marginLeft: 60,
          backgroundColor: "transparent",
          border: 0,
          cursor: "pointer",
        },
      }}
    >
      {videos.map((video, index) => {
        return (
          <div
            className="card-container"
            key={index}
            style={{ width: width ? width : "100%" }}
          >
            <CustomVideo
              srcVideo={video}
              number={index}
              length={videos.length}
              activeSlide={activeSlide}
            />
          </div>
        );
      })}
    </Carousel>
  );
};
